module.exports = __webpack_public_path__ + "static/DEV4-7de2f81ec22f26320e2fa1823321306d.png";